(function ($) {
  Drupal.behaviors.fullWidthPromoWithCtaMobileV1 = {
    attach: function (context, settings) {
      $('.full-width-promo-with-cta-mobile-v1').each(function () {
        var undef;
        var $tpl = $(this);
        var link = $tpl.find('.button').attr('href');

        if (link !== undef) {
          $tpl.once().on('click', function() {
            window.location.href = link;
          });
        }

        // Check if h2 is empty
        var h2First = $tpl.find('.content').children('h2:first-child');

        if (h2First.text().length === 0) {
          h2First.hide();
        }
      });
    }
  };
})(jQuery);
